export default __webpack_public_path__ + "static/media/PDPEditIconDisabled.ec35a770.svg";